<template>
    <div class="p-2">
        <div class="form-group d-flex border-bottom">
            <div class='col-6'>Title:</div><div class='col-18'>{{this.$parent.item.title}}</div>
        </div>

        <div class="form-group d-flex border-bottom">
            <div class='col-6'>Content:</div><div class='col-18'>{{this.$parent.item.content}}</div>
        </div>
        
        <div class="form-group d-flex border-bottom">
            <div class='col-6'>Start at:</div><div class='col-18'>{{this.$parent.item.start_at | formatDateTimeNullAware}}</div>
        </div>

        <div class="form-group d-flex border-bottom">
            <div class='col-6'>End at:</div><div class='col-18'>{{this.$parent.item.end_at | formatDateTimeNullAware}}</div>
        </div>

        <div class="form-group d-flex border-bottom">
            <div class='col-6'>Notice:</div><div class='col-18'>{{this.$parent.item.notice ? "Yes" : "No"}}</div>
        </div>

    </div>
</template>

<script>
	export default {
        methods: {
            getName() {
				return this.$parent.item.title;
			},
        }
    }
</script>
